import {
  InstagramPlatform,
  SocialPlatform,
  YoutubePlatform,
} from '@app/modules/social-export/domain/platforms';
import { Box } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { InstagramQuickExportSettings } from './platforms/InstagramQuickExportSettings';
import { YoutubeQuickExportSettings } from './platforms/YoutubeQuickExportSettings';

interface Props {
  platform: SocialPlatform;
  fieldPrefix?: string;
}

/**
 * Renders platform-specific export settings when the platform is enabled.
 * Only YouTube and Instagram currently expose additional settings.
 */
export function QuickSocialExportSettings({ platform, fieldPrefix }: Props) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fieldName = `${fieldPrefix || ''}.enabled`.replace(/^\./, '') as any;
  const enabled = useWatch({ name: fieldName });

  if (!enabled) {
    return null;
  }

  if (platform.id === YoutubePlatform.id) {
    return (
      <Box px={1.5} pb={1}>
        <YoutubeQuickExportSettings fieldPrefix={fieldPrefix} />
      </Box>
    );
  }

  if (platform.id === InstagramPlatform.id) {
    return (
      <Box px={1.5} pb={1}>
        <InstagramQuickExportSettings fieldPrefix={fieldPrefix} />
      </Box>
    );
  }

  return null;
}
